import { useEffect } from 'react'

import { Form, Radio, Space } from 'antd'
import { useForm } from 'antd/es/form/Form'

import CommonModal from '@/components/common/CommonModal'
import Info from '@/components/common/Info'

import { ActionProps, ActionTypes, RoundAction } from './types'

export type RoundForm = {
  decimal_places: number
  half: 'half_up' | 'half_even'
}

const Round = ({ onSubmit, onCancel, isVisible, initialValues, clearOptions }: ActionProps<RoundAction>) => {
  const values = initialValues as any
  const savedSpecs = values?.specs || {}
  const initial = {
    decimal_places:
      savedSpecs.decimal_places ??
      savedSpecs.decimalPlaces ??
      values?.decimal_places ??
      values?.decimalPlaces ??
      0,
    half: savedSpecs.half ?? values?.half ?? 'half_up'
  }
  const [form] = useForm<RoundForm>()

  useEffect(() => {
    if (clearOptions === true) {
      form.resetFields()
      form.setFieldsValue(initial)
    }
  }, [clearOptions, initialValues])

  const submitForm = () => {
    form.submit()
  }

  const onFinish = (values: RoundForm) => {
    onSubmit?.({
      actionType: ActionTypes.ROUND,
      specs: {
        decimal_places: values.decimal_places,
        half: values.half
      }
    })
  }

  const popoverContent = (
    <div>
      <strong>Function</strong>
      <p>Round the numeric values mapped into the object to a set number of decimal places.</p>
      <strong>How to use</strong>
      <p>Choose how many decimal places to keep and how to round values exactly halfway.</p>
      <strong>Notes</strong>
      <p>
        <em>
          Excel style rounds 2.5 up to 3; half to even rounds 2.5 to 2. Decimal places apply to the
          number stored in the data.
        </em>
      </p>
    </div>
  )

  return (
    <CommonModal
      title={
        <span>
          Round <Info>{popoverContent}</Info>
        </span>
      }
      visible={isVisible}
      onCancel={onCancel}
      onOk={submitForm}
    >
      <Form form={form} initialValues={initial} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="decimal_places"
          label="Decimal places"
          rules={[{ required: true }]}
        >
          <Radio.Group>
            <Space direction="horizontal">
              <Radio value={0}>0</Radio>
              <Radio value={1}>1</Radio>
              <Radio value={2}>2</Radio>
              <Radio value={3}>3</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="half" label="Halfway rule" rules={[{ required: true }]}>
          <Radio.Group>
            <Space direction="vertical">
              <Radio value="half_up">Round half up (Excel style)</Radio>
              <Radio value="half_even">Round half to even</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
      </Form>
    </CommonModal>
  )
}

export default Round
